'use strict';

Object.defineProperty(exports, "__esModule", { value: true });
exports.convertPhoneValue = exports.getPrefixList = exports.getPreloadedPrefix = exports.getPhoneValueAfterCountryChange = exports.PHONE_SEPARATOR = void 0;
var tslib_1 = require("tslib");
var arrays_1 = require("./arrays");
exports.PHONE_SEPARATOR = ' ';
/**
 * Returns the country prefix code for the phone based on the updated country code value
 * @param phoneTypeStateValue  phone type specific field in the state to work with
 * @param countryCode country code that has been updated
 * @returns phone prefix value to populate the dropdown with
 * */
function getPhoneValueAfterCountryChange(countries, phoneTypeStateValue, countryCode) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var country, prevValue, phoneValue, splitStateValue;
        return tslib_1.__generator(this, function (_a) {
            country = countries.countries.find(function (_a) {
                var code = _a.code;
                return code === countryCode;
            });
            prevValue = '';
            phoneValue = '';
            splitStateValue = phoneTypeStateValue.split(exports.PHONE_SEPARATOR);
            if (splitStateValue.length === 2) {
                prevValue = splitStateValue[1];
            }
            if (prevValue !== '' && country && country.phonePrefix) {
                phoneValue = country.phonePrefix + " " + prevValue;
                return [2 /*return*/, phoneValue];
            }
            else if (country && country.phonePrefix) {
                phoneValue = country.phonePrefix;
                return [2 /*return*/, phoneValue];
            }
            return [2 /*return*/, phoneValue];
        });
    });
}
exports.getPhoneValueAfterCountryChange = getPhoneValueAfterCountryChange;
function getPreloadedPrefix(countries) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var prefixes;
        return tslib_1.__generator(this, function (_a) {
            prefixes = getPrefixList(countries.countries).join(',');
            return [2 /*return*/, {
                    prefixes: prefixes,
                }];
        });
    });
}
exports.getPreloadedPrefix = getPreloadedPrefix;
function getPrefixList(countries) {
    var prefixes = countries
        .map(function (_a) {
        var phonePrefix = _a.phonePrefix;
        return phonePrefix;
    })
        .filter(function (prefix) { return !!prefix; });
    prefixes.sort();
    return arrays_1.uniqueValues(prefixes);
}
exports.getPrefixList = getPrefixList;
function convertPhoneValue(value) {
    return value ? value.split(exports.PHONE_SEPARATOR) : ['', ''];
}
exports.convertPhoneValue = convertPhoneValue;
